const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const UpdateConfig = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SAGA_GET_TEMPLATES":
      return { loading: true };
    case "GET_TEMPLATES_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    default:
      return state;
  }
};

export default UpdateConfig;
